import { render, staticRenderFns } from "./SuratPersetujuanTindakanBody.vue?vue&type=template&id=300e146e&"
import script from "./SuratPersetujuanTindakanBody.vue?vue&type=script&lang=js&"
export * from "./SuratPersetujuanTindakanBody.vue?vue&type=script&lang=js&"
import style0 from "./SuratPersetujuanTindakanBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports